import { ca } from '@cian/analytics';

/**
 * @description Событие: блок промо (карусель/зона акций) попал в зону видимости.
 */
export function trackShowPromosSection(): void {
  ca('eventSite', {
    action: 'show_landing_section',
    category: 'Promo',
    label: 'promos',
    name: 'oldevent',
    useLastProducts: true,
  });
}
